import { render, staticRenderFns } from "./DocumentDisplay.vue?vue&type=template&id=06b61fdc&scoped=true&"
import script from "./DocumentDisplay.vue?vue&type=script&lang=js&"
export * from "./DocumentDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDisplay.vue?vue&type=style&index=0&id=06b61fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b61fdc",
  null
  
)

export default component.exports